import * as React from "react";
import { isUndefined } from "lodash";

import { IControlError, IControlSchema } from "../../core/Controls";

import { Component, I18NString, parseTagSanitizeAndWhitelist} from "../helpers/Utils";
import { IDispatcher } from "../helpers/Dispatcher";

import Field from "./components/Field";
import ErrorAlert from "./components/ErrorAlert";

interface IRadiobuttonOption {
	label: I18NString;
	name: string;
}

interface IRadiobuttonSchema extends IControlSchema {
	value?: any;
	options: Array<IRadiobuttonOption>;
	disabled?: boolean;

	description: I18NString;
	defaultValue?: any;
	extra?: any;
}

interface IRadiobuttonProps {
	schema: IRadiobuttonSchema;
	api: any;
	dispatcher?: IDispatcher;
	error: IControlError | undefined;
	visited: boolean;
}

interface State {
	value: any;
	isOpen: boolean;
}

class Radiobutton extends Component<IRadiobuttonProps, State> {
	state = {
		value: null,
		isOpen: false,
	};

	componentDidMount() {
		const { value, defaultValue } = this.props.schema;
		if (!isUndefined(value)) {
			this.setState({
				value,
			});
		} else if (defaultValue) {
			this.setState({ value: defaultValue });
		}
	}

	onClick = (event: any) => {
		const { attributes } = event.target;
		const { value } = attributes.getNamedItem("data-value");
		this.setState({
			value,
		});
		this.props.dispatcher.onBlur(this.props.schema.id, value, true, undefined);
	};

	onOpenHelp() {
		this.setState(({ isOpen }) => ({
			isOpen: !isOpen,
		}));
	}

	render() {
		const {
			schema: { options, disabled, description, extra, id },
			error,
		} = this.props;
		const errorMessage = error && error.message;
		const namesInputs = options.map((option: IRadiobuttonOption) => ({
			...option,
			name: option.name,
		}));

		return (
			<Field {...this.props.schema} status={this.state.value ? "success" : "default"}>
				{extra && extra.hint && (
					<div className="alert alert-info hint" dangerouslySetInnerHTML={{ __html: extra.hint }} />
				)}
				<div className="input-group-cr">
					<div className="btn-group" style={{ display: extra?.isHorizontal &&  "flex" }}>
						{namesInputs.map((option: IRadiobuttonOption, idx: number) => (
							<label key={idx} className="radio-inline" style={{ flex: extra?.isHorizontal &&  "1" }}>
								<input
									type="radio"
									disabled={disabled}
									name={id}
									data-value={option.name}
									checked={option.name === this.state.value}
									onChange={this.onClick}
								/>
								{/* 
								// @ts-ignore */}
								{parseTagSanitizeAndWhitelist(this.tr(option.label) ?? option.label)}
							</label>
						))}
					</div>
					{description && (
						<span className="btn btn-default" onClick={this.onOpenHelp}>
							<span className="glyphicon glyphicon-question-sign" />
						</span>
					)}
				</div>
				{description && this.state.isOpen && (
					<div className="alert alert-warning" role="alert">
						{this.tr(description)}
					</div>
				)}
				<ErrorAlert errorMessage={errorMessage} />
			</Field>
		);
	}
}

export function createRadiobutton(
	schema: IControlSchema,
	api: any,
	dispatcher: IDispatcher = null,
	error: IControlError | undefined,
	visited: boolean
): React.ReactElement<any> {
	return (
		<Radiobutton
			schema={schema as IRadiobuttonSchema}
			api={api}
			error={error}
			visited={visited}
			dispatcher={dispatcher}
		/>
	);
}
